import React, { Component } from 'react';

import {
    Container,
    Row,
    Col,
    FormGroup, Label, Input,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';



import ListBuilder from './listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../helpers/linkHelper';
import { API_ENDPOINT, GOOGLE_API_KEY } from '../constants';
import moment from 'moment';
import eRemissIcon from '../assets/svg/e.svg';
import garabage from '../assets/svg/garbage.svg';


import Isvg from 'react-inlinesvg';
import Checkbox from './forms/fields/checkbox';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}




class ClinicGroupsStatisticsExports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: []

        };
    }

    getClinicGroupsStatisticsExports = () => {

        fetch(API_ENDPOINT + `/data/clinic-groups/statistic/exports/get`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                mainClinicGroups: this.props.mainClinicGroups ? true : false
            })
        }).then(res => res.json()).then((result) => {
            let items = result?.exports?.length ? result.exports : [];
            this.setState({ items }, () => {
                if (this.state.items?.find(item => !item?.finished)) {
                    setTimeout(() => {
                        this.get();
                    }, 1000 * 5);
                }
            });
        })
    }

    get = () => {
        this.getClinicGroupsStatisticsExports();


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();



    }

    componentWillUnmount() {
    }



    componentDidUpdate(prevProps, prevState) {


    }





    render() {

        const items = this.state.items || [];
        const selectedPaymentExport = this.props.isOpen !== true && this.props.isOpen?.length === 24 ? this.props.isOpen : null;

        return (
            <Modal
                isOpen={this.props.isOpen}
                centered
                size={this.props.size ? this.props.size : 'lg'}
                zIndex={this.props.zIndex ? this.props.zIndex : 1050}
            >
                <ModalHeader
                    toggle={() => {
                        this.props?.toggle?.()
                    }}
                    close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.props?.toggle?.()}>&times;</button>}
                >
                    {'Exports history'.translate(this.props.lang)}

                </ModalHeader>

                <ModalBody className="event-meetings-modal-body-wrap" style={{ maxHeight: '80vh', overflowY: 'auto' }}>

                    <div className="payment-exports-wrap">
                        {
                            items?.map((item, idx) => {
                                const url = item?.link ? `${API_ENDPOINT}${item?.link}` : null;
                                const isItemSelected = selectedPaymentExport === item?._id ? true : false;
                                return (
                                    <div className={isItemSelected ? 'payment-exports-item-wrap selected-payment-exports-item-wrap' : 'payment-exports-item-wrap'} key={idx}>
                                        <div className='export-data-wrap'>
                                            <div className='item-title'>{item.fileName}</div>
                                            <div className='item-subtitle'>
                                                {
                                                    item?.finished && item?.finishedTs ?
                                                        `${'Exported'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.finishedTs, `${this.props.dateFormat} HH:mm`)}`
                                                        :
                                                        `${'Export started'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.tsCreated, `${this.props.dateFormat} HH:mm`)}`
                                                }
                                                {
                                                    item?.user?.username ?
                                                        <>
                                                            <br />
                                                            {`${'Exported by'.translate(this.props.lang)}: ${item?.user?.username}`}
                                                        </>
                                                        :
                                                        null
                                                }
                                                {
                                                    item?.body?.dateFrom ?
                                                        <>
                                                            <br />
                                                            {`${'Date from'.translate(this.props.lang)}: ${item?.body?.dateFrom}`}
                                                        </>
                                                        :
                                                        null
                                                }
                                                {
                                                    item?.body?.dateTo ?
                                                        <>
                                                            <br />
                                                            {`${'Date to'.translate(this.props.lang)}: ${item?.body?.dateTo}`}
                                                        </>
                                                        :
                                                        null
                                                }
                                                {
                                                    item?.clinics ?
                                                        <>
                                                            <br />
                                                            {`${'Clinics'.translate(this.props.lang)}: ${item?.clinics}`}
                                                        </>
                                                        :
                                                        null
                                                }


                                            </div>
                                        </div>
                                        <div className='export-data-actions'>
                                            {
                                                !item?.finished ?
                                                    `${'In progress'.translate(this.props.lang)}...`
                                                    :
                                                    <>
                                                        {/* <button className='export-record-delete' onClick={() => this.deleteExportRecord(item._id)}> <Isvg src={garabage} />  <div className="export-record-delete-tooltip">{'Delete'.translate(this.props.lang)}</div> </button> */}
                                                        {
                                                            url ?
                                                                <a href={url} target={'_blank'}>{'Download'.translate(this.props.lang)}</a>
                                                                :
                                                                null
                                                        }

                                                    </>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </ModalBody>
                <ModalFooter className="buttons-right-blue event-meetings-modal-footer-wrap ">
                    <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.props?.toggle?.()} >
                        {this.props.closeButtonText ? this.props.closeButtonText : 'Close'.translate(this.props.lang)}
                    </Button>


                </ModalFooter>
            </Modal>
        );


    }
}
export default ClinicGroupsStatisticsExports;